import PigletArticleApi from '@/api/piglet/pigletArticleApi';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addOrUdpdate({dispatch}, {context, form}) {
      try {
        const response = await PigletArticleApi.addOrUpdate(context, form);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchAll({dispatch}, {context}) {
      try {
        const response = await PigletArticleApi.fetchAll(context);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async remove({dispatch}, {context, id}) {
      try {
        const response = await PigletArticleApi.remove(context, id);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
